<i18n src="../../locales/lang.json"></i18n>

<template>
  <div ref="mainDiv" class="form-group-feedback form-group-feedback-left flex-grow-1">
    <input  @change="handletextChange" @keypress.enter="handleEnter" @input="handleInput" ref="mySerarhInput" type="text" v-bind:placeholder="$t('search_terms')" class="form-control col-12" v-model="textInput">
    <div class="form-control-feedback form-control-feedback-lg">
      <i class="icon-search4 text-muted"></i>
    </div>
    <options-popup :options="filteredOptions"
                   :showOptions="showOptions && filteredOptions.length > 0"
                   :position="popupPosition" />
  </div>
  <!--<textarea ref="textarea" @input="handleInput" class="skin form-control messageinput" v-on:keyup.enter="reply" v-bind:placeholder="$t('enter_message')" v-model="message" v-bind:id="'messageinput' + threadid" style="float:left;"></textarea>
   <button type="button" class="btn skin primary-button" style="min-width:100px;float:right;" @click="reply">{{$t('post')}}</button>-->
</template>

<script>

  import OptionsPopup from '../discuss/options-popup.vue'; // Adjust path as per your file structure

  export default {

    name: 'forum-search',
    components: {
      OptionsPopup
    },
    props: {
      
    },
    data() {
      return {
        //
        textInput: '',
        content: '',          // To store textarea content
        showOptions: false,   // To control when to show options
        users: [],
        tags: [],
        filteredOptions: [],  // To store filtered options based on input
        cursorPosition: 0,    // To store current cursor position in textarea
        popupPosition: { x: 0, y: 0 },  // Position of the popup
      };
    },


    methods: {
      //
      handletextChange(event) {
        this.$root.$emit("doForum_Search");
      },
      handleEnter(event) {
        if (event.key === 'Enter') {
          this.$root.$emit("doForum_Search");
        }
      },
      async loadTags() {
        try {
          this.$http.get('/api/Threads/v1/Site').then(async response => {

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.toLowerCase();
                var y = b.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            this.tags = [];
            for (var i = 0; i < response.data.length; i++) {
              this.tags.push({
                id: response.data[i], name: response.data[i]
              });
            }
            console.log(this.tags);
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadUsers() {
        try {
          this.$http.get('/api/Users/v1').then(async response => {
            this.users = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            this.users = [];
            for (var i = 0; i < response.data.length; i++) {
              //if (i < 5) {
              this.users.push({
                id: response.data[i].UserName, name: response.data[i].Name
              });
              //}
            }
            //this.filterUsers();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      setPopupPosition() {
        // Get the position of the div relative to the viewport
        const rect = this.$refs.mainDiv.getBoundingClientRect();
        this.popupPosition = {
          x: 0,//rect.left,  // Example: X position based on mouse click event
          y: rect.top - 140,   // Example: Y position based on mouse click event
        };
      },
      handleInput(event) {
        this.setPopupPosition();
        // Access the cursor position
        const cursorPosition = event.target.selectionStart;
        //var m = $('#messageinput' + this.threadid).val();
        this.content = this.textInput;


        const contentBeforeCursor = this.content.substring(0, cursorPosition);

        // Check if "#" is typed and show options accordingly
        const lastWord = contentBeforeCursor.split(/\s+/).pop();
        if (lastWord && (lastWord.charAt(0) === '@' || lastWord.charAt(0) === '#')) {
          const query = lastWord.substring(1).toLowerCase(); // Get the query after "#"

          if (lastWord.charAt(0) === '@') {
            this.filteredOptions = this.users.filter(option =>
              option.name.toLowerCase().includes(query)
            );
          } else {
            this.filteredOptions = this.tags.filter(option =>
              option.name.toLowerCase().includes(query)
            );
          }

          //if (this.filteredOptions.length < 4) {
          //  this.popupPosition = {
          //    x: 0,//rect.left,  // Example: X position based on mouse click event
          //    y: this.popupPosition.y, //+ (120 - (30 * this.filteredOptions.length)),   // Example: Y position based on mouse click event
          //  };
          //}


          this.showOptions = true;
          // Attach click event listener to close popup when clicking outside
          document.addEventListener('click', this.onClickOutside);
          this.cursorPosition = cursorPosition; // Save cursor position for insertion
        } else {
          this.showOptions = false;
          // Remove click event listener when popup is hidden
          document.removeEventListener('click', this.onClickOutside);
        }
      },
      selectOption(index) {

        const contentBeforeCursor = this.content.substring(0, this.cursorPosition);

        // Check if "#" is typed and show options accordingly
        const lastWord = contentBeforeCursor.split(/\s+/).pop();
        let cursorPositionStart = this.cursorPosition;
        let cursorPositionEnd = this.cursorPosition;
        if (lastWord && (lastWord.charAt(0) === '@' || lastWord.charAt(0) === '#')) {
          const query = lastWord.substring(1).toLowerCase();
          if (query.length > 0) {
            cursorPositionStart = this.cursorPosition - query.length;
            cursorPositionEnd = this.cursorPosition + query.length;
          }
        }

        // Replace text after "#" with selected option
        const selectedOption = this.filteredOptions[index];
        const optionName = selectedOption.id + ' ';
        let start = cursorPositionStart; //- (this.content.split(/\s+/).pop().length) + 1;
        const end = cursorPositionEnd + 1;
        const newText = this.content.substring(0, start) + optionName + this.content.substring(end);

        this.content = newText;
        this.showOptions = false;
        this.textInput = newText;
        var currentthis = this;
        this.$nextTick(() => {
          // Set cursor position after inserted option
          const newCursorPosition = start + optionName.length;
          //textarea.selectionStart = newCursorPosition;
          //textarea.selectionEnd = newCursorPosition;
          currentthis.$refs.mySerarhInput.focus();
          currentthis.$refs.mySerarhInput.setSelectionRange(newCursorPosition, newCursorPosition); // Example: Select characters 2 to 7
          currentthis.$root.$emit("doForum_Search");
        });
        //this.$forceUpdate();
      },

      onClickOutside(event) {
        // Check if clicked element is outside the popup
        if (this.showOptions && this.filteredOptions.length > 0) {
          this.showOptions = false;
          // Remove event listener after closing popup
          document.removeEventListener('click', this.onClickOutside);
        }
      }
    },
    mounted() {
      this.loadUsers();
      this.loadTags();
    },

    computed: {
    },

    created: function () {

    },

    updated() {

    },


  }

</script>
<style>
</style>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forum/forum-search.vue